import React, {memo} from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'

import EstateItem from './EstateItem'

export const ESTATE_FRAGMENT = gql`
  fragment Estate on EstatesConnection {
    edges {
      node {
        id
        streetAddress
        createdAt
        segment {
          id
          name
          iconUrl
          backgroundColor
        }
        broker {
          id
          name
        }
        tasks {
          title
          productId
          productType
          completed
        }
        products(toCustomer: true) {
          edges {
            node {
              id
              name
              state
              requiresUserInput
              canProvideUserInput
              ...on PhotoBasedProduct {
                quantity
              }
            }
          }
        }
      }
    }
  }
`

const EstateList = ({estates, showBroker}) => {
  return (
    <>
      {estates.map(estate => (
        <EstateItem
          key={estate.id}
          estate={estate}
          showBroker={showBroker}
        />
      ))}
    </>
  )
}

EstateList.propTypes = {
  estates: PropTypes.array,
  showBroker: PropTypes.bool,
}

export default memo(EstateList)
